// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_93444fe79c--tag--NyUph","tag_close":"_93444fe79c--tag_close--vIsGX"};